<template>
  <div class="privacy-container">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>隐私声明</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="privacy-content">
      <h1 class="privacy-title">隐私声明</h1>
      
      <div class="privacy-divider">
        <div class="privacy-divider-line"></div>
      </div>
      
      <div class="privacy-body">
        <p class="privacy-intro">
          本条款所称"江泰公司"是指江泰保险经纪股份有限公司及其直接或间接控股的公司。江泰公司的业务是建立在与客户彼此信任的基础之上的，为了向您提供更优质的客户服务和产品，江泰公司将通过www.jiangtai.com网站（以下简称"本网站"）收集您的部分信息。为了使您提供的所有信息都能得到机密保障，江泰公司对关于隐私保密政策说明如下：
        </p>

        <section class="privacy-section">
          <p>
            江泰公司致力于保护您在使用江泰保险网站时所提供的私隐、私人资料以及个人的资料（统称 "个人资料"），使江泰公司在收集、使用、储存和传送个人资料方面符合与个人资料私隐有关的法律法规，以及消费者保护方面的标准。为确保您对江泰公司在处理个人资料上有充分信心，请您详细阅读及理解隐私条款的条文，特别是您一旦使用江泰公司网站, 将被视为接受、同意、承诺和确认：您自愿同意向我们披露个人资料；您会遵守本隐私条款的全部条文和限制；您在江泰公司网站上作登记、资料会被收集；您同意日后我们对隐私条款的任何修改；您同意江泰公司的分公司、附属公司、雇员、就您可能会感兴趣的产品和服务与您联络（除非您已经表示不想收到该类讯息）。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">被收集的个人资料的种类</h2>
          <p>
            经您同意，江泰公司会收集、管理个人资料，为了向您提供并进一步改善江泰公司的服务，包括但不限于：个人资料、您的姓名、性别、年龄、出生日期、电话号码、传真号码、住址或通讯地址、电子邮箱地址、不具名的资料。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">收集个人资料及不具名资料的目的及用途</h2>
          <p>
            通过江泰公司网站向您提供各项服务； 当您使用江泰公司网站时，能辨认及确认您的身份；让您使用江泰公司网站时得到为您而设的感受；江泰公司的服务人员与您联系；统计江泰公司网站使用量的数据；令您使用江泰公司网站时更方便；为改进产品、服务及网站内容而进行市场研究调查；遵守法律、政府和监管机关的规定，包括但不限于对个人资料披露及通知的规定，让江泰公司及可能处于您所在国家之外的我们的分公司、附属公司、关联公司、雇员、代理人、服务伙伴或其它跟我们合作的第三者进行产品、服务的推广；就我们提供的各项服务，分析、核对、审查您的信用、付款能力；处理在您要求下的任何付款指示, 直接扣帐及信用安排；使您能运作您的账户，并使江泰公司能从账户支取尚欠的费用。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">Cookies</h2>
          <p>
            当您到访江泰公司网站时，Cookie是发送到您的浏览器上并在您的电脑硬盘驱动器上存储的小量数据。只有当您使用您的电脑进入江泰公司网站时，Cookie才能够被发送到您的电脑硬盘上。Cookies常用于记录访问者浏览网站上的各个项目时的习惯以及偏好。Cookies所搜集的资料是不记名的集体统计数据，不载有个人资料。Cookies不能用于取得您的硬盘上的数据、您的电邮地址、及您的私人数据。当您重新访问江泰公司网站时，可以省却您再次登记的步骤。大多数浏览器都预设为可以接受Cookies，您可以选择将您的浏览器设定为不接受Cookies，不过，若设定为禁止Cookies，您或许不能启动或使用江泰公司网站的某些功能。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">保存个人资料及不具名资料</h2>
          <p>
            您提供给江泰公司的个人资料及不具名资料，只保留到搜集的目的已达到的时候，除非应适用的法律法规之规定而继续保留。在江泰公司网站上所搜集的一切资料都由江泰公司所拥有，不会出租或出售给任何无关的第三方。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">个人资料的保护</h2>
          <p>
            江泰公司实施适当的实物、电子、管理及技术方面的措施来保护和保障您的个人资料安全，尽力确保通过江泰公司网站所搜集的任何个人资料皆免于任何与江泰公司无关的第三方的滋扰。江泰公司采取的安全措施包括但不限于：实物措施，存有您个人资料的记录会被存放在有锁的地方；电子措施：存有您个人资料的电脑数据会被存放在受严格登入限制的电脑系统和存储媒体上；管理措施：只有经江泰公司授权的职员才能接触到您的个人资料，这些职员需要遵守江泰公司个人资料保密的内部守则；技术措施：可能采用加密技术来输送您的个人资料；其它措施：江泰公司的网络服务器受到"防火墙"的保护。尽管实施了上述技术和安全措施，江泰公司不能保证资料在互联网上的输送绝对安全，因此江泰公司不能绝对保证您通过江泰公司网站提供的个人资料在一切时候都是安全的，对任何因未经授权而接触您个人资料所发生的事件，江泰公司不承担责任，因此而导致的任何损失或损害，江泰公司也不负责赔偿。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">未成年人的个人信息保护</h2>
          <p>
            江泰公司非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用江泰公司的服务前，应事先取得您家长或法定监护人的书面同意。江泰公司根据国家相关法律法规的规定保护未成年人的个人信息的保密性及安全性。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">安全保管您的密码</h2>
          <p>
            除了江泰公司致力确保您的个人资料存放和处理的安全外，您不应向任何人披露您的登录密码或帐户资料，以保护您的个人资料。每当您登录江泰公司网站时，尤其是当您使用他人的电脑或者是公共的互联网终端机时，请操作完毕后点击退出。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">隐私条款的修改</h2>
          <p>
            本隐私条款可以被江泰公司修改，无需事先向您通知。
          </p>
        </section>

        <section class="privacy-section">
          <h2 class="privacy-subtitle">重要事项</h2>
          <p>
            您进入本网址及浏览其任何网页，即表示您同意遵守上述条款。谢谢选择江泰保险经纪股份有限公司。
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.privacy-container {
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  margin-top: 90px;
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.breadcrumb {
  margin-bottom: 25px;
}

.privacy-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.privacy-divider {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.privacy-divider-line {
  width: 60px;
  height: 4px;
  background-color: #fd4813;
  border-radius: 2px;
}

.privacy-body {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
}

.privacy-intro {
  font-size: 17px;
  margin-bottom: 25px;
  color: #555;
  line-height: 1.8;
}

.privacy-section {
  margin-bottom: 25px;
  padding-bottom: 5px;
}

.privacy-subtitle {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin: 25px 0 15px;
  position: relative;
  padding-left: 15px;
  border-left: 4px solid #fd4813;
}

.privacy-section p {
  margin-bottom: 15px;
  text-align: justify;
}

/* 响应式样式 */
@media (max-width: 992px) {
  .privacy-container {
    max-width: 95%;
    padding: 25px;
  }
  
  .privacy-title {
    font-size: 26px;
  }
  
  .privacy-subtitle {
    font-size: 18px;
  }
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 20px;
    margin-top: 70px;
  }
  
  .privacy-title {
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  .privacy-divider-line {
    width: 50px;
    height: 3px;
  }
  
  .privacy-intro {
    font-size: 16px;
  }
  
  .privacy-body {
    font-size: 15px;
    line-height: 1.7;
  }
  
  .privacy-subtitle {
    font-size: 17px;
    margin: 20px 0 12px;
  }
}

@media (max-width: 480px) {
  .privacy-container {
    padding: 15px;
    margin-top: 60px;
  }
  
  .breadcrumb {
    margin-bottom: 15px;
    font-size: 12px;
  }
  
  .privacy-title {
    font-size: 20px;
  }
  
  .privacy-divider-line {
    width: 40px;
  }
  
  .privacy-intro {
    font-size: 15px;
    margin-bottom: 20px;
  }
  
  .privacy-body {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .privacy-subtitle {
    font-size: 16px;
    padding-left: 10px;
    margin: 18px 0 10px;
  }
  
  .privacy-section {
    margin-bottom: 20px;
  }
}
</style>
